import { useEffect, useState } from "react";
import axios from "axios";

import { API_URL } from "../constants/constants";
import { useAuth0 } from "./react-auth0-spa";

const useSaldosAPI = (initialUser = "") => {
  // console.log(initialUser);
  const [user, setUser] = useState(initialUser);
  const [data, setData] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [isError, setIsError] = useState(false);
  const { isAuthenticated, getTokenSilently, user: user2 } = useAuth0();

  useEffect(() => {
    if (!user2) return;
    const fetchSaldo = async () => {
      setIsError(false);
      setIsLoading(true);

      const t = await getTokenSilently();

      try {
        const r = await axios.get(API_URL + `/saldos/${user2.sub}`, {
          headers: {
            Authorization: `Bearer ${t}`
            // "Access-Control-Allow-Origin": "*"
          }
        });
        setData(r.data);
        // console.log(r.data);
      } catch (error) {
        console.log(error);
        setIsError(true);
      }
      setIsLoading(false);
    };
    if (isAuthenticated) fetchSaldo();
  }, [user,getTokenSilently,isAuthenticated,user2]);

  return [{ data, isLoading, isError }, setUser];
};
export default useSaldosAPI;
